import { Action, createReducer, on } from '@ngrx/store';

import { Product } from '@planone/bau365/util-fair-data';

import * as DataAccessProductsActions from './data-access-products.actions';
import { productMock } from './data-access-products.mocks';

import * as DataAccessExhibitorsActions from '../../exhibitors/entity/data-access-exhibitors.actions';

export const DATA_ACCESS_PRODUCTS_FEATURE_KEY = 'dataAccessProducts';

export interface ProductsState {
  activeProductLoading?: boolean;
  activeProductError?: string;
  products: KeyedProductState;
}

interface KeyedProductState {
  [uuid: string]: Product;
}

export interface DataAccessProductsPartialState {
  readonly [DATA_ACCESS_PRODUCTS_FEATURE_KEY]: ProductsState;
}

export const initialProductsState: ProductsState = {
  products: {},
};

const dataAccessProductsReducer = createReducer(
  initialProductsState,
  on(DataAccessProductsActions.productOpened, (state, { productUuid }) => {
    const loaded = typeof state.products[productUuid] !== 'undefined';

    return {
      ...state,
      activeProductLoading: !loaded,
      activeProductError: undefined,
    };
  }),
  on(DataAccessProductsActions.productLoadSucceeded, (state, { product }) => ({
    ...state,
    activeProductLoading: false,
    activeProductError: undefined,
    products: {
      ...state.products,
      [product.id]: product,
    },
  })),
  on(DataAccessProductsActions.productLoadFailed, (state, { error }) => ({
    ...state,
    activeProductLoading: false,
    activeProductError: error,
  })),
  on(DataAccessProductsActions.productOpenedUnauthorized, (state, { productUuid }) => ({
    ...state,
    activeProductLoading: false,
    activeProductError: '401',
    products: {
      ...state.products,
      ['dummy-' + productUuid]: productMock,
    },
  })),
  on(DataAccessProductsActions.productsLoadSucceeded, (state, { products }) => {
    let updatedState = state;

    products.forEach((product) => {
      updatedState = {
        ...updatedState,
        products: {
          ...updatedState.products,
          [product.id]: product,
        },
      };
    });

    return updatedState;
  }),
  on(
    DataAccessExhibitorsActions.exhibitorProductsLoadNext,
    DataAccessExhibitorsActions.exhibitorProductsLoadSucceeded,
    (state, { exhibitorProductsResponse }) => {
      let object = {};

      exhibitorProductsResponse.items.forEach(
        (product) =>
          (object = {
            ...object,
            [product.id]: product,
          })
      );

      return {
        ...state,
        products: {
          ...state.products,
          ...object,
        },
      };
    }
  )
);

export function productsReducer(state: ProductsState | undefined, action: Action) {
  return dataAccessProductsReducer(state, action);
}
